// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo {
  position: relative;
  overflow: hidden;
  padding: 100px 0;
  background: radial-gradient(120% 140% at 50% 0%, var(--ink-700) 0%, var(--ink-800) 55%, var(--ink-900) 100%);
  text-align: center;
}

.promo__glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 680px;
  height: 680px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(0, 198, 167, 0.22), transparent 65%);
  filter: blur(10px);
  animation: promoPulse 5s ease-in-out infinite;
}

@keyframes promoPulse {
  0%,
  100% {
    opacity: 0.7;
    transform: translate(-50%, -50%) scale(0.94);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
}

.promo__floater {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: var(--glass-dark-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-dark-border);
  color: var(--teal);
  animation: promoFloat 4.5s ease-in-out infinite;
}

@keyframes promoFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-16px);
  }
}

.promo__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.promo__title {
  margin-top: 18px;
  max-width: 620px;
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 800;
  color: #fff;
}

.promo__text {
  margin-top: 18px;
  max-width: 560px;
  font-size: 15.5px;
  color: rgba(255, 255, 255, 0.68);
}

.promo__ctas {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 38px;
}

@media (max-width: 720px) {
  .promo__floater {
    display: none;
  }
  .promo {
    padding: 72px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Promo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4GAA4G;EAC5G,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,6EAA6E;EAC7E,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,YAAY;IACZ,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".promo {\n  position: relative;\n  overflow: hidden;\n  padding: 100px 0;\n  background: radial-gradient(120% 140% at 50% 0%, var(--ink-700) 0%, var(--ink-800) 55%, var(--ink-900) 100%);\n  text-align: center;\n}\n\n.promo__glow {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 680px;\n  height: 680px;\n  transform: translate(-50%, -50%);\n  background: radial-gradient(circle, rgba(0, 198, 167, 0.22), transparent 65%);\n  filter: blur(10px);\n  animation: promoPulse 5s ease-in-out infinite;\n}\n\n@keyframes promoPulse {\n  0%,\n  100% {\n    opacity: 0.7;\n    transform: translate(-50%, -50%) scale(0.94);\n  }\n  50% {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1.05);\n  }\n}\n\n.promo__floater {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  background: var(--glass-dark-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid var(--glass-dark-border);\n  color: var(--teal);\n  animation: promoFloat 4.5s ease-in-out infinite;\n}\n\n@keyframes promoFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-16px);\n  }\n}\n\n.promo__inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.promo__title {\n  margin-top: 18px;\n  max-width: 620px;\n  font-size: clamp(28px, 4vw, 42px);\n  font-weight: 800;\n  color: #fff;\n}\n\n.promo__text {\n  margin-top: 18px;\n  max-width: 560px;\n  font-size: 15.5px;\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.promo__ctas {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 38px;\n}\n\n@media (max-width: 720px) {\n  .promo__floater {\n    display: none;\n  }\n  .promo {\n    padding: 72px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
